import { gql } from "@apollo/client";

export default gql`
  query getMessageForAiSimulation($customerId: ID!, $messageId: ID!){
    getMessageForAiSimulation(customerId: $customerId, messageId: $messageId){
        success
        data{
            _id
            messageType
            content
            commentData{
                status
                reaction
                reply
                repliedCPerson
                replyDate
                aiNotResponseReason
                privateReply
                privateReplyId
                privateReplyAiNotResponseReason
                postUrl
                postImageUrl
                postDescription
                parentComment
                parentCommentId
                rating
                replyState
                policyViolation
                isAnonymous
                temporaryReply
                externalStatus
                reviewUpdateTime
            }
            questionData{
                status
                reply
                repliedCPerson
                replyDate
                productUrl
                productImageUrl
                productName
                productMainId
                sku
                isRepliedOnPlatform
                temporaryReply
                aiNotResponseReason
                replies{
                    content
                    repliedCPerson
                    replyDate
                    status
                    failedReason{
                        message
                        code
                        attempt
                    }
                    isRobot
                }
            }
            channel
            channelType
            previousMessages{
                _id
                role
                content
                isAiGenerated
            }
        }
        code
        message
    }
}
`
